<template>
    <div class="dsp-review" id ="reviewsSection">
        <h2 class="h3 text-bold">Reviews</h2>
        <ul ref="dspReviews">
            <template v-for="item in dsp.reviews">
                <li class="closed">
                    <div class="f5"> Submitted by {{item.who}} on {{item.postedAt}} </div>
                    <div class="rate">
                        <template v-for="index in 5">
                            <i class="icon-star" v-if="(item.quality - index) >= 0 "></i>
                            <i class="icon-star-half" v-else-if="(item.quality - index) > -1"></i>
                            <i class="icon-star-o" v-else></i>
                        </template>
                    </div>
                    <div class="desc">
                        {{item.comments}}
                    </div>
                    <a class="link reviewlink" target="_blank" rel="nofollow" :href="reviewUrl"> </a>
                </li>
            </template>
        </ul>
        <div class="flex left middle">
            <span class="f7">Source: <a class="link" href="http://greatschools.org/" rel="nofollow" target="_blank">GreatSchools.org</a> © {{new Date().getFullYear()}}. All rights reserved.</span>
            <img class="m-l-2" :src="glb.cdnUrl + `vimages/greatschool-logo.png`" alt="GreatSchools Logo" fetchpriority="auto">
        </div>
    </div>
</template>
<script src="./dsp-review.js"></script>
<style lang="scss">
@use "./dsp-review.scss" as *;
</style>